import { render } from "./AuthenticationRegister.vue?vue&type=template&id=89c5c650&scoped=true&ts=true"
import script from "./AuthenticationRegister.vue?vue&type=script&lang=ts"
export * from "./AuthenticationRegister.vue?vue&type=script&lang=ts"

import "./AuthenticationRegister.vue?vue&type=style&index=0&id=89c5c650&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c5c650"]])

export default __exports__